import { create } from 'zustand';
import type { PublicGameState } from '@durakapp/engine';
import type { MatchEndReason } from '@durakapp/shared';

interface MatchState {
  matchId: string | null;
  state: PublicGameState | null;
  ended: boolean;
  /** ms epoch deadline for the next required action; null until known. */
  turnDeadlineAt: number | null;
  endReason: MatchEndReason | null;
  forfeitedBy: string | null;
  setMatch: (matchId: string, state: PublicGameState, deadline: number | null) => void;
  setState: (state: PublicGameState, deadline: number | null) => void;
  markEnded: (state: PublicGameState, reason: MatchEndReason | null, forfeitedBy: string | null) => void;
  reset: () => void;
}

export const useMatch = create<MatchState>((set) => ({
  matchId: null,
  state: null,
  ended: false,
  turnDeadlineAt: null,
  endReason: null,
  forfeitedBy: null,
  setMatch: (matchId, state, deadline) =>
    set({ matchId, state, ended: false, turnDeadlineAt: deadline, endReason: null, forfeitedBy: null }),
  setState: (state, deadline) => set({ state, turnDeadlineAt: deadline }),
  markEnded: (state, reason, forfeitedBy) =>
    set({ state, ended: true, turnDeadlineAt: null, endReason: reason, forfeitedBy }),
  reset: () =>
    set({ matchId: null, state: null, ended: false, turnDeadlineAt: null, endReason: null, forfeitedBy: null }),
}));
